module.exports = __webpack_public_path__ + "static/media/okcomply-audit.c75a2efa.png";